export default {
  openDialog({ commit }) {
    return commit('openDialog');
  },
  closeDialog({ commit }) {
    return commit('closeDialog');
  },
};
